import React from 'react';
import {useSelector} from "react-redux";
import PeopleAltSharpIcon from "@material-ui/icons/PeopleAltSharp";
import DataTile from "../../metrics/DataTile";
import BBIconSocialTestIcon from "../../../../assets/bbCustomIcons/BBIconSocialTestIcon";

const TileAdminSocialCurrentTemplates = ({props})=>{
    const {templates, loadingTemplates, loadingTemplatesError} = useSelector(({admin})=>admin);

    const valueFunction = ()=> {
        if(loadingTemplatesError){
            return null
        } else{
            const currentTemplates = templates && templates.templates;
            return currentTemplates
                && Array.isArray(Object.keys(currentTemplates))
                && Object.keys(currentTemplates).length;

        }
    }

    return(
        <DataTile
            color="primary"
            subTitle="Current Templates Available"
            tipText={"Templates available."}
            icon={<BBIconSocialTestIcon style={{fontSize: "70px"}}/>}
            // stateFetchAction={fetchUsers()}
            forceLoadingState={!templates || loadingTemplates || loadingTemplatesError}
            valueFunction={()=> valueFunction ? valueFunction() : null}
        />
    )
}

export default TileAdminSocialCurrentTemplates;